// @ts-strict-ignore
import { IArticleConnectProcessor } from './i-article-connect.processor';
import { IOperation } from '@shared/undo/operation/i-operation';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ConnectionAreaVO, MetaElementUsageIdentityVO } from '@shared/vo/meta-element.vo';
import { ArticleVO } from '@article/model/vo/article.vo';
import { ProjectModel } from '@project/model/project.model';
import { ConnectArticlePrepareData } from '../insert/connect-article-prepare-data';
import { ArticleContainersWrapper } from '@3d-scene/model3d/article-containers-wrapper';
import { ArticleContainerUtils } from '@3d-scene/model3d/util/article-container-utils';
import { ArticleContainerPropertyDef } from '@article/constants/article-container-property-def';
import { ArticleTypeConstants } from '@article/constants/article-type-constants';
import { ArticleManager } from '@article/manager/article.manager';
import { CompositeArticleCacheManager } from '@article/manager/composite-article-cache.manager';
import { ArticleContainerLoader } from '@article/service/article-container-loader';
import { ArticleContainerFactory } from '@3d-scene/model3d/article-container.factory';
import { CompositeArticleUtils } from '@article/util/composite-article-utils';
import { AttachedArticleContainer } from '../../../service/article-container-attached.service';
import { ProjectModelService } from '@project/service/project-model.service';
import { ProjectArticleService } from '@project/service/project-article.service';
import { DetachArticleUsageService } from '@project/service/detach-article-usage.service';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { CompositeArticleInfoUtils } from '@article/util/composite-article-info-utils';

export class BaseSingleConnectionConnectProcessor implements IArticleConnectProcessor {

  constructor(
    protected projectModel: ProjectModel,
    protected projectModelService: ProjectModelService,
    protected projectArticleService: ProjectArticleService,
    protected articleContainerLoader: ArticleContainerLoader,
    protected compositeArticleCacheManager: CompositeArticleCacheManager,
    protected articleContainerFactory: ArticleContainerFactory,
    protected articleManager: ArticleManager,
    protected compositeArticleUtils: CompositeArticleUtils,
    protected compositeArticleInfoUtils: CompositeArticleInfoUtils,
    protected articleContainerUtils: ArticleContainerUtils,
    protected detachArticleUsageService: DetachArticleUsageService,
    protected containerService: ContainerService,
  ) {}

  public get createdUndoOperations(): IOperation[] {
    return null;
  }

  public clear(): void {}

  public preProcess(
    article: ArticleVO,
    connectArticlePrepareDatas: ConnectArticlePrepareData[],
    handler: Function,
    usageIdsToDetach: string[] = null
  ): void {
    if (!connectArticlePrepareDatas || connectArticlePrepareDatas.length === 0) {
      return;
    }
    const connectPrepareData: ConnectArticlePrepareData = connectArticlePrepareDatas[0];
    this.internalPreProcess(article, connectPrepareData, handler);
  }

  protected internalPreProcess(article: ArticleVO, connectPrepareData: ConnectArticlePrepareData, handler: Function): void {
    this.finalizePreProcess(article, connectPrepareData, null, handler);
  }

  protected finalizePreProcess(
    article: ArticleVO,
    connectPrepareData: ConnectArticlePrepareData,
    foundUsageIdsToDetach: string[],
    handler: Function
  ): void {
    const containerWrappers: ArticleContainersWrapper[] = this.createArticleWrappers(article, connectPrepareData);
    handler(containerWrappers, foundUsageIdsToDetach);
  }

  public process(
    containers: ArticleContainer[],
    baseContainer: ArticleContainer,
    givingConnectionAreas: ConnectionAreaVO[],
    rotationAngle: number
  ): void {
    // override this method
  }

  protected finalizeAttachContainer(compositionGuid: string, container: ArticleContainer, connectedTo: MetaElementUsageIdentityVO[]): void {
    this.articleContainerUtils.updateActiveSetInArticleContainers([container]);
    const data: AttachedArticleContainer = {
      articleGUID: container.articleGUID,
      compositionId: compositionGuid,
      container: container,
      connectedTo: connectedTo,
    };

    this.containerService.attachArticleContainer(data)
  }

  public postProcess(containers: ArticleContainer[]): void {}

  protected getGroupId(article: ArticleVO): string {
    return null;
  }

  private createArticleWrappers(article: ArticleVO, connectPrepareData: ConnectArticlePrepareData): ArticleContainersWrapper[] {
    const groupId: string = this.getGroupId(article);
    const containerWrappers: ArticleContainersWrapper[] = [];
    for (const cube of connectPrepareData.acceptingConnections) {
      const articlesWrapper: ArticleContainersWrapper =
        new ArticleContainersWrapper(
          article,
          groupId,
          ArticleTypeConstants.EXCLUDED_TYPES_FROM_COMPOSITE_ARTICLE,
          this.projectModel,
          this.projectArticleService,
          this.articleContainerLoader,
          this.compositeArticleCacheManager,
          this.articleContainerFactory,
          this.articleManager,
          this.articleContainerUtils,
          this.detachArticleUsageService
        );
      articlesWrapper.searchVectorId = connectPrepareData.vectorId;
      articlesWrapper.givingConnectionNames = connectPrepareData.givingConnectionNames;
      articlesWrapper.properties.setValue(ArticleContainerPropertyDef.ACCEPTING_CONNECTIONS, [cube]);
      containerWrappers.push(articlesWrapper);
    }
    return containerWrappers;
  }
}
